import React from 'react';
import { ToastContainer, Toast } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setToastData } from '../../reducer/utilitySlice';
import { SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';

const ToastMessage = () => {
  const {
    utilityData: { toastData },
  } = useSelector((state) => state);
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(
      setToastData({
        show: false,
        message: '',
      })
    );
  };

  return (
    // <section>
    //   <div class="container">
    //     <div
    //       class="toast align-items-center text-bg-primary border-0 new_toast_msg"
    //     //   role="alert"
    //     //   aria-live="assertive"
    //     //   aria-atomic="true"
    //     >
    //       <div class="d-flex justify-content-center">
    //         <div class="toast-body">Account successfully verified</div>
    //         {/* <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button> */}
    //       </div>
    //     </div>
    //   </div>
    // </section>

    <ToastContainer position="bottom-center">
      <Toast
        show={toastData.show}
        onClose={handleClose}
        autohide={true}
        delay={3000}
        className="align-items-center text-bg-primary border-0 new_toast_msg"
        // style={{ width: 'fit-content' }}
      >
        <div
          class="d-flex justify-content-center"
          style={{ alignItems: 'center' }}
        >
          {/* <Toast.Body>Account successfully verified</Toast.Body> */}
          {toastData.isIcon &&
          <img
            src={process.env.PUBLIC_URL + '/logo192.png'}
            alt="logo"
            height={24}
            width={24}
            style={{
              borderRadius: '8px',
              marginLeft: lang === 'en' ? '0.75rem' : '',
              marginRight: lang === 'en' ? '' : '0.75rem'
            }}
          />}
          <Toast.Body className='dir-ltrl'>{toastData.message}</Toast.Body>
        </div>
      </Toast>
    </ToastContainer>
  );
};

export default ToastMessage;
